var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ql-editor"},[_c('div',{staticClass:"box-shadow pad-16 wid-100",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }